// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab a[data-v-76b652d4] {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n.fitable-tab[data-v-76b652d4] {\n  display: flex;\n}\n.fitable-tab > li[data-v-76b652d4] {\n    width: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
